import { gql } from '@zenbusiness/application-commons-graphql';

export const REQUEST_NEW_CARD_MUTATION = gql`
  mutation requestNewCard($input: RequestNewCardInput!) {
    requestNewCard(input: $input) {
      id
    }
  }
`;
